import { render, staticRenderFns } from "./IncidentFieldList.vue?vue&type=template&id=50217134&scoped=true"
import script from "./IncidentFieldList.vue?vue&type=script&lang=js"
export * from "./IncidentFieldList.vue?vue&type=script&lang=js"
import style0 from "./IncidentFieldList.vue?vue&type=style&index=0&id=50217134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50217134",
  null
  
)

export default component.exports